/* Figma 598:542376 — a two-column grid: Field Name | Crop on the first row, Crop Year alone in the
   first column of the second. `gap-[13px]` and `gap-[20px]` map to the nearest tokens. */
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: var(--space-3);
  row-gap: var(--space-5);
}
